import { Condition } from "@redotech/redo-model/return-flow/condition";
import {
  productPropertyFromModel,
  validateProductPropertyCondition,
  type ProductPropertyState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const PRODUCT_PROPERTY = (
  Details: React.ComponentType<ConditionTypeDetailsProps<ProductPropertyState>>,
): ConditionType<ProductPropertyState, Condition.ProductProperty> => ({
  name: "Product properties",
  description(state) {
    return `Product properties: ${state.join(", ")}`;
  },
  Details(props: ConditionTypeDetailsProps<ProductPropertyState>) {
    return React.createElement(Details, props);
  },
  empty: [],
  fromModel(model: Condition.ProductProperty) {
    return productPropertyFromModel(model);
  },
  toModel(state) {
    return { type: Condition.PRODUCT_PROPERTY, properties: state };
  },
  valid(state) {
    return validateProductPropertyCondition(state).valid;
  },
});

export { type ProductPropertyState } from "@redotech/redo-model/return-flow/condition-validate";
